import React from "react";
import { Customers } from "../features";
import { Grid } from "@material-ui/core";

function CustomersPage() {
  return (
    <>
      <Customers.Container />
    </>
  );
}

export default CustomersPage;
